import { LEGAL_LINKS, LegalLanguage } from "@constants/legalLinks";
import i18n from "@i18n/i18n";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography
} from "@mui/material";
import { pillButtonContained } from "@theme/styles";
import { useTranslation } from "react-i18next";

export interface LegalConditionsDialogProps {
  open: boolean;
  onAccept: () => void;
  onClose: () => void;
}

const LegalConditionsDialog: React.FC<LegalConditionsDialogProps> = ({
  open,
  onAccept,
  onClose
}) => {
  const { t } = useTranslation();

  const currentLanguage = (i18n.language as LegalLanguage | undefined) ?? "ca";

  const links = LEGAL_LINKS[currentLanguage];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: 4,
          p: { xs: 2, sm: 3 },
          pb: { xs: 3, sm: 3.5 },
          boxShadow: "none"
        }
      }}
    >
      <DialogTitle
        sx={{
          textAlign: "center",
          fontSize: 20,
          fontWeight: 600,
          pb: 2
        }}
      >
        {t("legal_dialog.title")}
      </DialogTitle>

      <DialogContent
        sx={{
          pt: 0,
          px: { xs: 1, sm: 0 }
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
          <Typography
            sx={{
              fontSize: 16,
              lineHeight: "20px",
              fontWeight: 325,
              color: "#000000"
            }}
          >
            {t("legal_dialog.paragraph1")}
          </Typography>

          <Typography
            sx={{
              fontSize: 16,
              lineHeight: "20px",
              fontWeight: 325,
              color: "#000000"
            }}
          >
            {t("legal_dialog.paragraph2")}
          </Typography>

          <Typography
            sx={{
              fontSize: 16,
              lineHeight: "20px",
              fontWeight: 325,
              color: "#000000"
            }}
          >
            {t("legal_dialog.links_prefix")}{" "}
            <Box
              component="a"
              href={links.conditions}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: "#000000",
                textDecoration: "underline"
              }}
            >
              {t("legal_dialog.links_conditions")}
            </Box>{" "}
            {t("legal_dialog.links_middle")}{" "}
            <Box
              component="a"
              href={links.privacy}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: "#000000",
                textDecoration: "underline"
              }}
            >
              {t("legal_dialog.links_privacy")}
            </Box>
            .
          </Typography>
        </Box>

        <Box
          sx={{
            mt: 4,
            display: "flex",
            justifyContent: "center"
          }}
        >
          <Button
            variant="contained"
            disableElevation
            onClick={onAccept}
            sx={{
              ...pillButtonContained("#000000"),
              px: { xs: 2.5, sm: 5 },
              maxWidth: 326,
              whiteSpace: "nowrap"
            }}
          >
            {t("legal_dialog.accept_button")}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default LegalConditionsDialog;
